module.exports = __webpack_public_path__ + "static/media/zwzproduct11.522ef416.jpg";